import { normalizeUiLocale } from '../../i18n/locales.js';
import { applyTourOverlays } from '../tours/overlays.js';
import { filterPageTourSteps, filterStepsByDom } from './filterSteps.js';
import { matchPageTour } from './matchRoute.js';

import './definitions/admin.js';
import './definitions/my.js';
import './definitions/superAdmin.js';
import './definitions/profile.js';

/**
 * @param {import('../tours/types.js').TourUser | null | undefined} user
 * @param {string} pathname
 */
export async function resolvePageTourSteps(user, pathname) {
  if (!user?.role) {
    return [];
  }
  const def = matchPageTour(pathname);
  if (!def) {
    return [];
  }
  const filtered = filterPageTourSteps(def.steps, user);
  const visible = await filterStepsByDom(filtered);
  return applyTourOverlays(visible, normalizeUiLocale(user.ui_locale));
}

export { matchPageTour } from './matchRoute.js';
